// extracted by mini-css-extract-plugin
export default {"rel":"lazyImageLoader_rel__YdDVm","abs-center":"lazyImageLoader_abs-center__fgKMi","mobile-inline-block":"lazyImageLoader_mobile-inline-block__VC4h6"};